import { createNestablePublicClientApplication, SilentRequest } from "@azure/msal-browser";
import VueRouter from 'vue-router'
import { Store } from 'vuex'


class NestedAppAuthenticationManager
{
  private pca:any;

  async init()
  {

    this.pca = await createNestablePublicClientApplication({
      auth: {
        clientId: "a914875b-8432-4380-b997-06c702b94a72",
        authority: "https://login.microsoftonline.com/organizations"
      },
    });

  }

  async getToken($store: Store<any>, $router: VueRouter)
  {
    if(this.pca == null) {

      await this.init();
    }

    const tokenRequest: SilentRequest = {
      scopes: ["Mail.Read", "Mail.ReadBasic.Shared", "User.ReadBasic.All", "openid", "profile"],
    };
    const account = this.pca.getActiveAccount();
    if(account != null)
    {
      tokenRequest.account = account;
    }

    let accessToken = null;

    try {
      console.log("Trying to acquire token silently...");
      const userAccount = await this.pca.acquireTokenSilent(tokenRequest);
      console.log("Acquired token silently.");
      accessToken = userAccount.accessToken;

      return accessToken;
    } catch (error) {
      console.log(`Unable to acquire token silently: ${error}`);
    }

    if (accessToken === null) 
    {
      try 
      {
        console.log("Trying to acquire token interactively...");
        const userAccount = await this.pca.acquireTokenPopup(tokenRequest);
        console.log("Acquired token interactively.");
        accessToken = userAccount.accessToken;
      } 
      catch (popupError) 
      {
        console.log(`Unable to acquire token interactively: ${popupError}`);
      }
    }

    if (accessToken === null) 
    {
      $store.dispatch('setErrorMessage', 'Authentification Office 365 échouée');
      $router.push({ name: 'office-auth-failed', params: { showHome: 'true'} });
      console.error(`Unable to acquire access token.`);
      throw new Error();
    }
  }
}

export default new NestedAppAuthenticationManager();
